import { Truck, Store, Utensils, Package, Building } from "lucide-react";

export const SUPPLIER_CATEGORIES = [
  { value: "mayorista", label: "Mayorista", Icon: Truck, color: "bg-amber-50 text-amber-700 border-amber-200" },
  { value: "supermercado", label: "Supermercado", Icon: Store, color: "bg-sky-50 text-sky-700 border-sky-200" },
  { value: "especialista", label: "Especialista", Icon: Utensils, color: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  { value: "distribuidor", label: "Distribuidor", Icon: Package, color: "bg-violet-50 text-violet-700 border-violet-200" },
  { value: "otros", label: "Otros", Icon: Building, color: "bg-muted/50 text-foreground border-border" },
];

export const getCategoryMeta = (value) =>
  SUPPLIER_CATEGORIES.find(c => c.value === value) || SUPPLIER_CATEGORIES[4];
